<template>
  <el-form
    label-width="150px"
    :model="fM"
    ref="sFormRef"
  >
    <el-row>
      <el-col
        :key="index"
        v-for="(item, index) in fS"
        :span="7"
        :offset="2"
      >
        <el-form-item
          :label="item.label"
          :prop="item.prop"
        >
          <div :class="{'input-with-suffix': item.suffix}">
            <template v-if="item.component==='el-date-picker'">
              <component
                :is="item.component"
                :type="item.type"
                :placeholder="item.placeholder"
                :filterable="item.filterable"
                :remote="item.remote"
                :remote-method="item.remoteMethod"
                :loading="item.loading"
                :disabled-date="item.disabledDate"
                style="width:100%;min-width:230px"
                v-model="fM[item.prop]"
                clearable
              />
            </template>
            <template v-else>
              <component
                :is="item.component"
                :type="item.type"
                :placeholder="item.placeholder"
                :filterable="item.filterable"
                :remote="item.remote"
                :remote-method="item.remoteMethod"
                :loading="item.loading"
                style="width:100%;min-width:230px"
                v-model="fM[item.prop]"
                clearable
              >
                <template v-if="item.component==='el-select'">
                  <el-option
                    v-for="(optionItem, optionIndex) in item.options"
                    :key="optionIndex"
                    :label="optionItem.label"
                    :value="optionItem.value"
                  />
                </template>
              </component>
            </template>
            <span
              v-if="item.suffix"
              class="suffix-text"
            >
              {{ item.suffix }}
            </span>
          </div>
        </el-form-item>
      </el-col>
      <el-col
        :span="4"
        :offset="bOffset()"
      >
        <el-button
          :disabled="resetDisabled"
          @click="resetEmit"
        >
          {{ t(resetButton) }}
        </el-button>
        <el-button
          type="primary"
          :disabled="submitDisabled"
          @click="submitEmit"
        >
          {{ t(submitButton) }}
        </el-button>
      </el-col>
    </el-row>
  </el-form>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useClickLock } from '@/utils/useClickLock'

export default defineComponent({
  props: {
    formModel: {
      type: Object,
      default: () => {
        return null
      }
    },
    formStruct: {
      type: Array,
      default: () => []
    },
    formRules: {
      type: Object,
      default: () => {
        return null
      }
    },
    submitButton: {
      type: String,
      required: false,
      default: 'common.submit'
    },
    resetButton: {
      type: String,
      required: false,
      default: 'common.reset'
    }
  },
  emits: ['submit', 'reset'],
  setup(props, context) {
    const { t } = useI18n()
    const sFormRef = ref()
    const fM = ref(props.formModel)
    const fS = ref(props.formStruct)
    const { disabled: submitDisabled, lock: submitLock } = useClickLock(2000)
    const { disabled: resetDisabled, lock: resetLock } = useClickLock(2000)
    const bOffset = () => {
      if ((props.formStruct.length % 2) === 0) {
        return 2
      }
      return 11
    }
    const submitEmit = () => {
      submitLock(() => {
        context.emit('submit')
      })
    }
    const resetEmit = () => {
      resetLock(() => {
        sFormRef.value.resetFields()
        context.emit('reset')
      })
    }
    return {
      t,
      fM,
      fS,
      sFormRef,
      submitDisabled,
      resetDisabled,
      bOffset,
      submitEmit,
      resetEmit
    }
  }
})
</script>

<style lang="scss">
.input-with-suffix {
  display: flex;
  align-items: center;
  width: 100%;
  min-width: 230px;
}

.input-with-suffix :deep(.el-input),
.input-with-suffix :deep(.el-date-editor),
.input-with-suffix :deep(.el-select) {
  flex: 1;
  margin-right: 8px;
}

.suffix-text {
  color: #606266;
  font-size: 14px;
  white-space: nowrap;
  min-width: 20px;
  margin-left: 5px;
}</style>
